import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Fonts (lokal aus npm — kein Google-CDN-Request)
import '@fontsource/outfit/index.css';
import '@fontsource/public-sans/index.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/theme.scss';

// Iconify offline: Tabler-Icon-Daten lokal aus @iconify-json/tabler bundlen,
// damit garantiert keine Requests an api.iconify.design gehen. mdi wird
// aktuell nicht verwendet — bei Bedarf hier zusätzlich addCollection().
import { addCollection, _api } from '@iconify/react';
import tablerIcons from '@iconify-json/tabler/icons.json';
addCollection(tablerIcons);
// Externe API komplett abschalten — falls jemand ein nicht registriertes
// Icon referenziert, sehen wir das durch ein leeres Symbol statt durch
// einen ungewollten Request.
if (_api && typeof _api.setAPIConfig === 'function') {
  _api.setAPIConfig({ resources: [] });
}

import App from './App.jsx';
import { AuthProvider } from './lib/auth.jsx';

// Live-Updates: alle Queries werden per Default
//   - alle 15 Sekunden im Hintergrund refresht (refetchInterval)
//   - sofort beim Tab-Wechsel/Window-Focus refresht (refetchOnWindowFocus)
//   - sofort wenn das Netzwerk nach Offline-Phase wieder kommt (refetchOnReconnect)
//   - staleTime kurz (5 s) damit React-Query die Daten als "verbrauchsbedürftig" sieht
// Pages die polling NICHT wollen können das pro Query mit `refetchInterval: false`
// individuell abschalten.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: 15_000,
      refetchIntervalInBackground: false
    }
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
